export default __webpack_public_path__ + "static/media/logo138x75white.4dc1f360.png";